<template>
  <div>
    
    <div v-if="viewConfig.EnableAlipayPayment && showPayment" class="form-row">
      <div class="custom-control custom-radio col-md-8 ml-4">
        <input
          id="payByAlipayInput"
          value="4"
          type="radio"
          name="customCheckbox"
          class="custom-control-input"
          @change="setPaymentMethod(4)"
          v-model="value"
        />
        <label
          class="custom-control-label ml-1"
          for="payByAlipayInput"
        >{{ $t("message.payByAlipay") }}</label>
      </div>
    </div>

    <div v-if="viewConfig.EnableWechatPayment && showPayment" class="form-row">
      <div class="custom-control custom-radio col-md-8 ml-4">
        <input
          id="payByWechatInput"
          value="5"
          type="radio"
          name="customCheckbox"
          class="custom-control-input"
          @change="setPaymentMethod(5)"
          v-model="value"
        />
        <label
          class="custom-control-label ml-1"
          for="payByWechatInput"
        >{{ $t("message.payByWechat") }}</label>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AppConfig } from "./../../../../AppConfig.js";
const stripeToken = AppConfig.stripeToken;
export default {
  data() {
    return {
      showApplePayBtn: false,
      showGooglePayBtn: false,
      showAppleSetupBtn: false,
      error: "",
      stripe: null,
    };
  },
  mounted() {
    var that = this;

    // eslint-disable-next-line no-undef
    this.stripe = Stripe(stripeToken);
    this.paymentRequest = this.stripe.paymentRequest({
      country: "AU",
      currency: "aud",
      total: {
        label: this.selectedCompany.Name,
        amount: parseInt(this.getTotalPrice * 100, 10), // total in cent
      },
      requestPayerName: false,
      requestPayerEmail: false,
    });

    // Check the availability of the Payment Request API first.
    this.paymentRequest.canMakePayment().then(function (result) {
      if (result) {
        if (result.applePay) {
          that.showApplePayBtn = true;
          that.showGooglePayBtn = false;
        } else {
          that.showGooglePayBtn = true;
          that.showApplePayBtn = false;
        }
      } else {
        that.showApplePayBtn = false;
        that.showGooglePayBtn = false;
      }
    });
  },
  computed: {
    ...mapGetters([
      "viewConfig",
      "getTotalPrice",
      "selectedCompany",
      "storeSupportsLoyaltyPoints",
    ]),
    showPayment() {
      var checkOtherEnablePaymentType =
        this.isPayByPointEnable ||
        this.isPayByCashEnable ||
        this.viewConfig.EnableWechatPayment ||
        (this.viewConfig.EnableApplePayment && this.showApplePayBtn )|| 
        (this.viewConfig.EnableGooglePayment && this.showGooglePayBtn);
      return checkOtherEnablePaymentType;
    },
    showPayByAppleOption() {
      return this.viewConfig.EnableApplePayment &&
        this.showApplePayBtn &&
        this.showPayment;
    },
    showPayByGoogleOption() {
      return this.viewConfig.EnableGooglePayment &&
        this.showGooglePayBtn &&
        this.showPayment;
    },
  },
  watch: {
    showPayByAppleOption(newValue) {
      this.$emit('set-show-pay-by-apple', newValue);
    },
    showPayByGoogleOption(newValue) {
      this.$emit('set-show-pay-by-google', newValue);
    },
  },
  props: {
    isPayByCashEnable: {
      type: Boolean,
      default: false,
    },
    isPayByPointEnable: {
      type: Boolean,
      default: false,
    },
    cardValueInPoint: {
      type: Number,
      default: 0,
    },
    value: {
      type: Number,
      default: 1,
    }
  },
  methods: {
    setPaymentMethod(val) {
      this.$emit("set-payment-method", val);
    },
  },
};
</script>